import { Component } from '@verndale/core';

class ConsentModal extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el as HTMLDialogElement,
      closeButton: this.el.querySelector('.btn--primary') as HTMLButtonElement
    };

    this.openModal();
  }

  addListeners(): void {
    (this.dom.closeButton as HTMLButtonElement)?.addEventListener('click', () => {
      this.closeModal();
    });

    // Prevent closing with ESC key
    (this.dom.el as HTMLDialogElement)?.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    });
  }

  openModal() {
    (this.dom.el as HTMLDialogElement).showModal();
  }

  closeModal() {
    (this.dom.el as HTMLDialogElement).close();
  }
}

export default ConsentModal;
